/**
 * Espace mega-menus (BOMI, WAMA): hover + click, panel fixed below header.
 */
function initEspaceMegaMenu(menuItem) {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  const panelId = menuItem.dataset.espaceMegaPanel;
  const trigger = menuItem.querySelector('.espace-bomi-mega__trigger');
  const panel = panelId ? document.getElementById(panelId) : null;
  const headerWrapper = document.querySelector('.header-wrapper');

  if (!trigger || !panel) return;

  let closeTimer = null;

  const positionPanel = () => {
    if (!headerWrapper) return;
    panel.style.top = `${headerWrapper.getBoundingClientRect().bottom}px`;
  };

  const open = () => {
    window.clearTimeout(closeTimer);
    document.querySelectorAll('[data-espace-mega-menu].is-open').forEach((other) => {
      if (other === menuItem) return;
      other.classList.remove('is-open');
      const otherPanel = document.getElementById(other.dataset.espaceMegaPanel);
      const otherTrigger = other.querySelector('.espace-bomi-mega__trigger');
      if (otherPanel) otherPanel.hidden = true;
      if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
    });
    positionPanel();
    menuItem.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    if (headerWrapper) headerWrapper.classList.add('menu-open');
  };

  const close = () => {
    menuItem.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    if (headerWrapper) headerWrapper.classList.remove('menu-open');
  };

  const scheduleClose = () => {
    closeTimer = window.setTimeout(() => {
      if (trigger.matches(':hover') || panel.matches(':hover')) return;
      close();
    }, 280);
  };

  trigger.addEventListener('mouseenter', () => {
    if (isDesktop()) open();
  });

  trigger.addEventListener('mouseleave', () => {
    if (isDesktop()) scheduleClose();
  });

  panel.addEventListener('mouseenter', () => {
    window.clearTimeout(closeTimer);
    if (isDesktop()) open();
  });

  panel.addEventListener('mouseleave', () => {
    if (isDesktop()) scheduleClose();
  });

  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (menuItem.classList.contains('is-open')) {
      close();
    } else {
      open();
    }
  });

  document.addEventListener('click', (event) => {
    if (!menuItem.contains(event.target) && !panel.contains(event.target)) {
      close();
    }
  });

  trigger.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  window.addEventListener('resize', positionPanel);
  window.addEventListener(
    'scroll',
    () => {
      if (!panel.hidden) positionPanel();
    },
    { passive: true }
  );
}

function initEspaceMegaMenus() {
  document.querySelectorAll('[data-espace-mega-menu]').forEach((menuItem) => {
    initEspaceMegaMenu(menuItem);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEspaceMegaMenus);
} else {
  initEspaceMegaMenus();
}
